import React from 'react';
import { translate } from 'react-i18next';
import moment from 'moment';

// Services
import { getTranslateDocSpecialties } from 'src/views/practitioner/services/appointments';

// Styles
import { AppInfCaption, AppInfCaptionContent } from '../styles';

export default translate()(({ i18n, appointmentData, practitionersList }) => {
  const patientData = appointmentData && appointmentData.patient;
  const practitionerData =
    appointmentData &&
    appointmentData.practitionerId &&
    Array.isArray(practitionersList) &&
    practitionersList.find(pr => pr.id === appointmentData.practitionerId);

  return (
    <AppInfCaption>
      <p>{i18n.t('detected_information')}</p>
      <AppInfCaptionContent>
        {/* ──── Patient ────────────────────────────────────────────────────────────────────── */}
        <div>
          <p className="label">{i18n.t('patient')} :</p>
          {patientData ? (
            <p>
              <span>
                <span className="last-name">{patientData.lastName} </span>
                <span>{patientData.firstName}</span>
              </span>
              <span className="full-width">
                <span className="additional-info">
                  {moment(patientData.birthDate).format('DD.MM.YYYY')}
                </span>
                <span className="additional-info with-left-border">
                  {i18n.t(
                    patientData.gender ? `gender_${patientData.gender.toLowerCase()}` : 'no_data'
                  )}
                </span>
              </span>
            </p>
          ) : (
            <p>
              <span>{i18n.t('no_data')}</span>
            </p>
          )}
        </div>

        {/* ──── Practitioner ────────────────────────────────────────────────────────────────── */}
        <div>
          <p className="label">{i18n.t('practitioner')} :</p>
          {practitionerData ? (
            <p>
              <span>{practitionerData.name}</span>
              <span className="additional-info full-width">
                {getTranslateDocSpecialties(practitionerData)}
              </span>
            </p>
          ) : (
            <p>
              <span>{i18n.t('no_data')}</span>
            </p>
          )}
        </div>
      </AppInfCaptionContent>
    </AppInfCaption>
  );
});
